import React, { useState } from 'react';

export const AnnouncementsContext = React.createContext(
  {}, // default value
);

type Props = {
  children: React.Node,
};

export const AnnouncementsProvider = (props: Props) => {
  const [message, setMessage] = useState(null);

  const getMessage = () => {
    const tmp = message;
    setMessage(null);
    return tmp;
  };

  return (
    <AnnouncementsContext.Provider value={{getMessage, setMessage}}>
      {props.children}
    </AnnouncementsContext.Provider>
  )
}